namespace Matrix.Dashboards {
    export interface DataSourceExtractParametersRequest extends Serenity.ServiceRequest {
        DataSourceType?: string;
        Properties?: { [key: string]: any };
    }
}
